<template>
  <div class='detail' @click.stop='showDetail(info.id)'>
    <div class='top'>
      <p class='header'>{{info.title}}</p>
      <p class='descripe'>
        <span class='salary'>{{info.salary | salaryFilter}}</span>
        <span class='prop'>{{info.education | educationFilter}}</span>
        <span class='line'>&nbsp;</span>
        <span class='prop'>{{info.yearOfWorking | jobExperiencesFilter}}</span>
      </p>
      <p class='number same'><i class='iconfont icon-renshu'></i><span>招聘{{info.number}}人</span></p>
      <p class='jobstatus same'><i class='iconfont icon-zhiwei'></i><span>{{info.jobType | jobTypeFilter}}</span></p>
    </div>
    <p class='footer'><span class='left'>{{info.corpName}}</span><span class='right'>{{info.createTime | DateFilter}}</span></p>
    <!-- <div class="remark">
      <div class="remarkTitle">附言</div>
      <p class="remarkText">{{info.remark}}</p>
    </div> -->
  </div> 
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    showDetail(id) {
      // this.$router.push({ path: `/humanResource/jobDetail/${id}` });
      console.log(this.info);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.detail{
  margin-bottom: 20px;
  // padding: .133333rem 0;
  border: 1px solid #c4c4c4;
  .top{
    padding: .4rem;
    background: #ffffff;
    .header{
      line-height: .746667rem;
      font-weight: 700;
      font-size: .453333rem;
      color: rgb(51, 51, 51);
    }
    .descripe{
      font-weight: 600;
      .salary{
        margin-right: .16rem;
        color: $color-main;
        font-size: .4rem;
      }
      .prop{
        color: rgb(51, 51, 51);
        font-size: .266667rem
      }
      .line{
        display: inline-block;
        border-right: 1px solid rgb(51, 51, 51);
        line-height: .266667rem;
        vertical-align: middle;
      }
    }
    .same{
      line-height: .64rem;
      font-size: .32rem;
      color: rgb(51, 51, 51);
      .iconfont{
        color: rgb(153, 153, 153);
        font-size: .32rem;
      }
    }
  }
  .footer{
    @include clear-float;
    padding: 10px 30px;
    background: #f9f9f9;
    font-size: .266667rem;
    color: #666666;
    .left, .right{
      display: inline-block;
      vertical-align: middle;
    }
    .left {
      float: left;
    }
    .right{
      float: right;
    }
  }
  .remark{
    margin-top: .32rem;
    padding: .32rem;
    .remarkText{
      border: 1px solid rgb(245, 245, 245);
      margin-top: .32rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/orderComponents/JobDemo.vue